import * as React from 'react';
import { inject } from 'mobx-react';
import { ErrorBoundary } from 'bernie-view';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { ExperienceTemplateRenderer } from 'experience-template-renderer-react';
export const ToolbarRegion = inject('experiment', 'multiItem')(({
  templateComponent
}) => {
  const {
    children
  } = templateComponent;
  if (!children || children.length === 0) {
    return null;
  }
  return React.createElement(ErrorBoundary, {
    label: "hotel.masterPage.toolbar"
  }, React.createElement(EGDSSpacing, {
    margin: {
      medium: {
        blockstart: 'two'
      },
      large: {
        blockstart: 'three'
      }
    }
  }, React.createElement("section", null, children && React.createElement(ExperienceTemplateRenderer, {
    templateComponents: children
  }))));
});